import { useI18n } from '../../../provider/i18n'
import useBasketData from '../../../hooks/useBasketData'
import ProfileCompletionForm from '../../../components/ProfileCompletionForm'

const Profiles = () => {
  const i18n = useI18n()
  const { incompleteProfiles } = useBasketData()

  return (
    <div id="profiles-section" className="flex flex-col gap-2">
      <span className="text-lg md:text-xl font-bold">
        {i18n.t('screens.basket.sections.profiles.title')}
      </span>
      <ul className="flex flex-col gap-1">
        {incompleteProfiles.map((profile, i) => (
          <li
            key={`test-${profile.id}-${i}`}
            className="border-b border-b-border border-opacity-20 p-2 md:px-4 bg-white flex flex-col md:flex-row gap-4 rounded-lg min-h-16 justify-center"
          >
            <ProfileCompletionForm profile={profile} />
          </li>
        ))}
      </ul>
    </div>
  )
}

export default Profiles
